var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCuredLogoGreenNoText = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_1411_3889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.151 25a1.646 1.646 0 00-2.34 0c-2.36 2.378-5.503 3.673-8.864 3.664-3.361-.015-6.528-1.35-8.917-3.758-4.926-4.965-4.968-13.002-.091-17.915 4.877-4.914 12.854-4.872 17.782.094a1.646 1.646 0 002.34 0 1.676 1.676 0 000-2.358C20.843-1.54 10.766-1.581 4.598 4.633-1.569 10.847-1.527 21 4.69 27.264l.001.002C7.702 30.3 11.694 31.98 15.934 32h.075c4.217 0 8.173-1.646 11.145-4.64a1.68 1.68 0 00-.003-2.36z",
    fill: "#113133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.986 23.273c-.236 0-.474-.043-.704-.136-.895-.36-1.305-1.32-.916-2.145 1.49-3.163 1.467-6.798-.062-9.972-.396-.823.005-1.787.897-2.152.892-.365 1.936.004 2.332.827 1.93 4.007 1.957 8.6.073 12.598-.288.613-.938.98-1.62.98z",
    fill: "#00855B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_1411_3889"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCuredLogoGreenNoText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cured-logo-green-no-text.fde80e2088636a93671f4f5bce9092a2.svg";